import { SendTeamsMessageForm } from '@features/send-teams-message/components/SendTeamsMessageForm'
import { Box, Card, ScrollArea } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'
import { requireRouteAudience } from '@services/router/routeAccess'

export const Route = createFileRoute('/_layout/tools/send-teams-message')({
    beforeLoad: requireRouteAudience(['staff']),
    component: RouteComponent,
    staticData: {
        crumb: {
            label: 'Send a Teams message',
        }
    }
})

function RouteComponent() {
    return (
        <ScrollArea h="100%" className="min-h-0" offsetScrollbars="y">
            <Box p="xs">
                <Card
                    withBorder
                    p="lg"
                >
                    <SendTeamsMessageForm />
                </Card>
            </Box>
        </ScrollArea>
    )
}
